module.exports = __webpack_public_path__ + "img/gb9118_2_l1.prt.cadb1190.jpg";